<template>
  <b-card class="card-chats">
    <b-card-header>
      <b-row align-h="between">
        <b-col cols="auto" class="mr-auto">
          <ModalCriarGrupo />
        </b-col>
        <b-col cols="auto">
          <ModalConfiguracoesUsuario />
        </b-col>
      </b-row>
    </b-card-header>
    <b-card-body>
      <b-row v-if="chatsUsuario && chatsUsuario.length >0" class="row-chats">
        <b-col class="col-chat lista-chats" cols="4">
          <ListaChats @carregandoChatAtual="carregandoChatAtual" />
        </b-col>
        <b-col class="col-chat" cols="8">
          <div v-if="loadingChatAtual" class="text-center">
            <b-spinner
              style="width: 3rem; height: 3rem;"
              variant="primary"
              label="loading chat messages"
            />
          </div>
          <ChatComponent v-else />
        </b-col>
      </b-row>
      <b-alert
        v-else
        show
        variant="secondary"
        class="alert-sem-chats"
      >
        No chats requests
      </b-alert>
    </b-card-body>
  </b-card>
</template>

<script>
import CloseIcon from 'vue-beautiful-chat/src/assets/close-icon.png';
import OpenIcon from 'vue-beautiful-chat/src/assets/chat-icon.png';
import FileIcon from 'vue-beautiful-chat/src/assets/file.svg';
import CloseIconSvg from 'vue-beautiful-chat/src/assets/close.svg';

import { mapActions, mapGetters } from 'vuex';
import ListaChats from './ListaChats.vue';
import ModalCriarGrupo from './modalCreateGroup/ModalCriarGrupo.vue';
import ModalConfiguracoesUsuario from './modalConfiguracoesUsuario/ModalConfiguracoesUsuario.vue';
import ChatComponent from './ChatComponent.vue';

export default {
  components: {
    ListaChats,
    ModalCriarGrupo,
    ChatComponent,
    ModalConfiguracoesUsuario,
  },
  data() {
    return {
      loadingChatAtual: false,
    };
  },
  async created() {
    try {
      await this.listarChatsUsuarios(this.usuarioLogado);
      if (this.$route.params.chatId) {
        const chat = this.chatsUsuario.find(
          (c) => c.id === this.$route.params.chatId,
        );
        if (chat) {
          this.definirChatAtual(chat);
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters(['chatsUsuario', 'usuarioLogado', 'chatAtual']),
  },
  methods: {
    ...mapActions(['listarChatsUsuarios', 'definirChatAtual']),
    carregandoChatAtual(carregando) {
      this.loadingChatAtual = carregando;
    },
  },
};
</script>

<style scoped>

.chat-fullscreen {
  box-shadow: 1px 1px 3px 1px rgba(0,0,0,0.15);
  border-radius: 10px;
  margin-left: 12px;
}
.col-chat {
  padding: 0px;
}
.chat {
  width: 100%;
  padding: 0px;
  margin: 0px;
}
.k-chat {
  max-width: 100%;
}
.lista-chats {
  overflow: auto;
  max-height: 600px;
}
.card-chats {
  height: 100%;
}
.alert-sem-chats {
  text-align: center;
  font-size: 120%;
}
.row-chats {
  height: 100%;
  min-height: 600px;
}
.card-header {
  border-radius: 5px;
}

</style>
